<template>
  <div class="authentification">
    <div class="app-name-content">
      <div class="app-name">
        AboRacco
      </div>
      <img src="../assets/mobile.png" alt="">
      <div class="app-description">
        Version mobile (2026.42.1)
      </div>
    </div>
    <div class="content-login">
      <div class="message" v-if="!message">Authentification</div>
      <transition name="bounce">
        <div class="message red" v-if="message">
          {{ message }}
        </div>
      </transition>
      <b-form-input v-model="User.login" type="text" placeholder="Identifiant CAS"></b-form-input>
      <b-form-input v-model="User.password" type="password" placeholder="Mot de passe" v-on:keyup.enter="login"></b-form-input>
      <b-button :disabled="disabled === 1" class="btn-login" v-on:click="login" variant="outline-danger">Connexion</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'authentification',
  data () {
    return {
      User: {
        login: null,
        password: null,
        token: null
      },
      message: null,
      disabled: false
    }
  },
  methods: {
    login: function (event) {
      if (this.User.login !== '' && this.User.password !== '') {
        this.disabled = 1
        this.$http.post('user/auth', JSON.stringify(this.User)).then(response => {
          this.response = response.json().then((data) => {
            if (data.token) {
              localStorage.setItem('token', data.token)
              localStorage.setItem('login', this.User.login)
              this.$clearStorage()
              this.$router.push('/accueil')
            }
            this.disabled = false
          })
        }, (response) => {
          if (response.status === 401) {
            this.message = 'Humm, il semble que vos identifiants soient incorrects'
          } else {
            this.message = 'Une erreur inconnue est survenue'
          }
          this.disabled = false
        })
      } else {
        this.message = 'Merci de remplir tous les champs'
      }
    }
  },
  mounted: function () {
    localStorage.removeItem('token')
    localStorage.removeItem('login')
    localStorage.removeItem('password')
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Authentification.vue